module.exports = __webpack_public_path__ + "static/media/tt.c3647d9b.svg";